import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Appt Components
import Box from '../../../components/simple/box/Box';
import ResponsiveGrid from '../../../components/compound/responsiveGrid/ResponsiveGrid';

// App widgets
import SimpleCounter from '../../../components/compound/simpleCounter/SimpleCounter';

// Shared Components

import LocalStorageService from '../../../services/LocalStorageService';

const terms = LocalStorageService.get('terms');

const MedicalInterventionReport = props => {
  const navigate = useNavigate();

  const [ numIncidentsInvolvingInjuryToChild, setNumIncidentsInvolvingInjuryToChild] = useState(0);

  const [ numIncidentsInvolvingInjuryToStaff, setNumIncidentsInvolvingInjuryToStaff] = useState(0);

  const [ numIncidentsInvolvingInjuryToOthers, setNumIncidentsInvolvingInjuryToOthers] = useState(0);

  const [ numIncidentsRestrictedInterventionUsed, setNumIncidentsRestrictedInterventionUsed] = useState(0);

  const [ totalNumberOfIncidentsByStudentGroup, setTotalNumberOfIncidentsByStudentGroup] = useState([]);

  const [ totalNumberOfIncidentsByDate, setTotalNumberOfIncidentsByDate] = useState([]);

  const [ totalNumberOfIncidentsByHour, setTotalNumberOfIncidentsByHour] = useState([]);
  const [ averageNumberOfStaffPerIncidentByLocation, setAverageNumberOfStaffPerIncidentByLocation] = useState([]);

  const [ otherChildrenInvolvedInIncident, setOtherChildrenInvolvedInIncident] = useState([]);

  const [relatedIncidents, setRelatedIncidents] = useState([]);

  const terms = LocalStorageService.get('terms');

  const printScreen = () => {
    window.print();
  };

  useEffect(() => {
    // Map the API data in props.location.state into the relevant datasets

    // Child injuries
    if (props?.reportData?.numIncidentsInvolvingInjuryToChild) {
      const numIncidentsInvolvingInjuryToChild =
        props?.reportData?.numIncidentsInvolvingInjuryToChild;

      setNumIncidentsInvolvingInjuryToChild(numIncidentsInvolvingInjuryToChild);
    }

    // Staff injuries
    if (props?.reportData?.numIncidentsInvolvingInjuryToStaff) {
      const numIncidentsInvolvingInjuryToStaff =
        props?.reportData?.numIncidentsInvolvingInjuryToStaff;

      setNumIncidentsInvolvingInjuryToStaff(numIncidentsInvolvingInjuryToStaff);
    }

    // Other injuries
    if (props?.reportData?.numIncidentsInvolvingInjuryToOthers) {
      const numIncidentsInvolvingInjuryToOthers =
        props?.reportData?.numIncidentsInvolvingInjuryToOthers;

      setNumIncidentsInvolvingInjuryToOthers(
        numIncidentsInvolvingInjuryToOthers,
      );
    }

    // Restricted Physical Intervension
    if (
      props?.reportData?.numberIncidentsRestrictedInterventionUsed
    ) {
      setNumIncidentsRestrictedInterventionUsed(
        props?.reportData?.numberIncidentsRestrictedInterventionUsed,
      );
    }

    // Other Children
    if (props?.reportData?.otherChildrenInvolvedInIncident) {
      const otherChildrenInvolvedInIncident =
        props?.reportData?.otherChildrenInvolvedInIncident;

      // Remove dupicates and add counts
      if (otherChildrenInvolvedInIncident) {
        const childrenCount = otherChildrenInvolvedInIncident.reduce(
          (newArray, child) => {
            const str = JSON.stringify(child);
            newArray[str] = (newArray[str] || 0) + 1;
            return newArray;
          },
          {},
        );

        const otherChildrenInvolvedInIncidentLabels = [];
        const otherChildrenInvolvedInIncidentData = [];

        for (const x in childrenCount) {
          otherChildrenInvolvedInIncidentLabels.push(JSON.parse(x).name);
          otherChildrenInvolvedInIncidentData.push(childrenCount[x]);
        }
        setOtherChildrenInvolvedInIncident([
          otherChildrenInvolvedInIncidentData,
          otherChildrenInvolvedInIncidentLabels,
        ]);
      }
    }

    // Student Group
    const totalNumberOfIncidentsByStudentGroup =
      props?.reportData?.numIncidentsInvolvingInjuryByStudentGroup;

    if (totalNumberOfIncidentsByStudentGroup) {
      const totalNumberOfIncidentsByStudentGroupLabels = totalNumberOfIncidentsByStudentGroup.map(
        (data, index) => {
          return data.userGroup;
        },
      );

      const totalNumberOfIncidentsByStudentGroupData = totalNumberOfIncidentsByStudentGroup.map(
        (data, index) => {
          return data.count;
        },
      );

      setTotalNumberOfIncidentsByStudentGroup([
        totalNumberOfIncidentsByStudentGroupData,
        totalNumberOfIncidentsByStudentGroupLabels,
      ]);
    }

    // Date
    const totalNumberOfIncidentsByDate =
      props?.reportData?.totalNumberOfIncidentsByDate;

    if (totalNumberOfIncidentsByDate) {
      const totalNumberOfIncidentsByDateLabels = totalNumberOfIncidentsByDate.map(
        (data, index) => {
          return data.month || 'n/a';
        },
      );

      const totalNumberOfIncidentsByDateData = totalNumberOfIncidentsByDate.map(
        (data, index) => {
          return data.count;
        },
      );

      setTotalNumberOfIncidentsByDate([
        totalNumberOfIncidentsByDateData,
        totalNumberOfIncidentsByDateLabels,
      ]);
    }

    // Time
    const totalNumberOfIncidentsByHour =
      props?.reportData?.totalNumberOfIncidentsByHour;

    if (totalNumberOfIncidentsByHour) {
      const totalNumberOfIncidentsByHourLabels = totalNumberOfIncidentsByHour.map(
        (data, index) => {
          return data.hour || 'n/a';
        },
      );

      const totalNumberOfIncidentsByHourData = totalNumberOfIncidentsByHour.map(
        (data, index) => {
          return data.count;
        },
      );

      setTotalNumberOfIncidentsByHour([
        totalNumberOfIncidentsByHourData,
        totalNumberOfIncidentsByHourLabels,
      ]);
    }

    // Location
    if (
      props?.reportData?.averageNumberOfStaffPerIncidentByLocation
    ) {
      const averageNumberOfStaffPerIncidentByLocation =
        props?.reportData?.averageNumberOfStaffPerIncidentByLocation;

      const averageNumberOfStaffPerIncidentByLocationLabels = [];
      const averageNumberOfStaffPerIncidentByLocationData = [];

      for (var x in averageNumberOfStaffPerIncidentByLocation) {
        if (x === 'null') {
          x = null;
        }
        averageNumberOfStaffPerIncidentByLocationLabels.push(x || 'n/a');
        averageNumberOfStaffPerIncidentByLocationData.push(
          averageNumberOfStaffPerIncidentByLocation?.[x]?.numIncidents || 0,
        );
      }

      setAverageNumberOfStaffPerIncidentByLocation([
        averageNumberOfStaffPerIncidentByLocationData,
        averageNumberOfStaffPerIncidentByLocationLabels,
      ]);
    }
  }, [props.reportData]);


  return (
    <Box width='xlarge' gap='medium' margin={{ bottom: 'medium' }}>
        <ResponsiveGrid
          rows={['auto']}
          columns={{
            small: ['auto'],
            medium: ['auto', 'auto', 'auto', 'auto'],
            large: ['auto', 'auto', 'auto', 'auto'],
            xlarge: ['auto', 'auto', 'auto', 'auto'],
          }}
          gap="small"
        >
          <SimpleCounter
            count={String(numIncidentsInvolvingInjuryToChild || 0)}
            label={
              terms?.serviceUser
                ? `Incidents involving injury to ${
                    terms?.serviceUser?.charAt(0)?.toUpperCase() +
                    terms?.serviceUser?.slice(1)
                  }`
                : 'Incidents involving injury to Student'
            }
            onClick={() => {
              props.addFilter('injurySufferedBy', 'student');
            }}
          />
          <SimpleCounter
            count={String(numIncidentsInvolvingInjuryToStaff || 0)}
            label="Incidents involving injury to staff member"
            onClick={() => {
              props.addFilter('injurySufferedBy', 'staff');
            }}
          />
          <SimpleCounter
            count={String(numIncidentsInvolvingInjuryToOthers || 0)}
            label="Incidents involving injury to other"
            onClick={() => {
              props.addFilter('injurySufferedBy', 'other');
            }}
          />
        </ResponsiveGrid>
    </Box>
  );
};

export default MedicalInterventionReport;
